export const locale = {
  lang: {
    russian: "Русский",
    uzbekLatin: "O‘zbek (Lotin)",
    uzbekKrill: "Ўзбек (кирилл)",
    qrLatın: "Qaraqalpaq (Latın)",
    kr: "Qaraqalpaq (Latın)",
  },
  lotin: " (latinsha)",
  search: "Izlew",
  selectedVakant: "Saylanǵan bos jumıs orınları",
  obnamuna: "Obiektivka úlgisi",
  staff_requirement_1: "Lawazımdıń iskerlik baǵdarı hám wazıypaları",
  staff_requirement_2: "Lawazım ushın rásmiy talaplar",
  with_me: "Biz benen tómendegi nátiyjelerge erisiwińiz múmkin",
  staff_requirement_card_1:
    "Barlıq miynet sharayatları jaratılǵan zamanagóy keńse",
  staff_requirement_card_2: "Zamanagóy pikirleytuǵın hám tatıw miynet jámááti",
  staff_requirement_card_3:
    "Múnásip is haqı (arnawlı ataq-mártebe dárejesi, miynet stajı, aylıq jeke ústeme hám basqa qosımshalar)",
  staff_requirement_card_4:
    "Isenimli xızmet karyerası, joqarı lawazımlarǵa kóteriliw múmkinshiligi",
  staff_requirement_card_5:
    "Professional xızmetkerler arasında úlken is tájiriybesi hám bahasız kásiplik kónlikpelerdi arttırıw múmkinshiligi",
  staff_requirement_card_6:
    "Shet elde mamanlıq asırıw hám stajirovka ótew múmkinshiligi",
  home: {
    menuText1: "Ádillik uyımları hám shólkemlerinde",
    menuText2: "Bos jumıs orınları",
    search: "Ádillik uyımları hám shólkemleri",
    countEnnounment: "Aktiv daǵazalar",
    countEnnounmentInactive: "Arxivtaǵı daǵazalar",
    searchRegion: "Aymaq boyınsha izlew",
    searchJob: "Lawazım boyınsha izlew",
    statistic: "Statistika",
    vacancyCount: "Daǵazalar",
    vacancies: "Bos jumıs orınları",
    applicants: "Hújjet tapsırǵanlar",
    recruited: "Jumısqa alınǵanlar",
    lavozim: "Lawazım",
    vacancy: "Bos jumıs ornı",
    company: "Ózbekstan Respublikası Ádillik ministrligi",
    havola: "Biziń mánziller",
    nomzod: "Talapkerler",
    close: "Jabıw",
    sendDocument: "Hújjetlerdi jiberiw",
    aboutLavozim: "Lawazım haqqında",
    aboutAll: "ulıwma maǵlıwmat",
    vazirlik: "Ministrlik",
    bolim: "Basqarma (bólim)",
    lavozimToifa: "Lawazım kategoriyası",
    lavozim: "Lawazım",
    jobOn: "Bos jumıs ornı",
    createDate: "Daǵaza berilgen sánesi",
    finishDate: "Daǵazanıń juwmaqlanıw sánesi",
    modalTitle:"ID kartańızdı alǵaningizdan keyin, OneID sistemasındaǵı maǵlıwmatlarıńızdı jańalang",
    skipping: "Ótkerip jiberiw",
    updateInformation: "Malummotlarni jańalaw "
  },
  status: "Jaǵdayı",
  seriaNumber: "Pasport seriyasi hám nomeri",
  secury: {
    fullMsg:
      "Parol keminde 8 belginen hám eń bolmaǵanda bir kishi hárip, bir úlken hárip, bir nomer hám bir arnawlı belginen ibarat bolıwı kerek.",
    msg1: "Parol ",
    msg2: "keminde 8 belgiden ",
    msg3: "eń bolmaǵanda bir nomerden ",
    msg4: "eń bolmaǵanda bir kishi háripten ",
    msg5: "eń bolmaǵanda bir úlken háripten ",
    msg6: "eń bolmaǵanda bir arnawlı belginen ",
    msg7: "ibarat bolıwı kerek.",
    msg8: "Kirill álipbesinen paydalanbań",
    successPswdSecury: "Parol qabıllandı.",
    successNoPswdSecury: "Parol qabıl etilmedi.",
  },
  photoCan: "Talapkerdiń suwreti",
  usernameAlready: "Bul paydalanıwshınıń atı aldınnan bar",
  isSaved: "Kiritilgen maǵlıwmatlardı saqlaysiz ba?",
  messages: "Xabarlar",
  org: "Shólkem",
  annoucement: "Daǵazalar",
  additionalDoc: "Qosımsha hújjetlerdi júklew",
  expireDateMessage: "Test tapsırıw ushın berilgen múddet tawsıldı",
  pasportInfo: "Pasport maǵlıwmatları",
  showArizaInfo: "Talapkerdiń arzası",
  finishSure: "Sınaqtı juwmaqlawıńızǵa tayarsız ba",
  testAnswers: "Test juwapları",
  expiredDate: "Tawısıw múddeti",
  givenDate: "Berilgen sáne",
  createdDate: "Daǵaza qosılǵan sáne",
  variantlar: "Variantlar",
  inPercent: "Test juwabı procentte",
  result: "Nátiyje",
  testResult: "Test nátiyjeleri",
  doc: "Hújjetler",
  nameDoc: "Hújjet atı",
  allTest: "Jámi sorawlar sanı",
  allTestCorrect: "Tuwrı juwaplar sanı",
  EmployeeFIO: "Talapker",
  allTestNoCorrect: "Nadurıs juwaplar sanı",
  forLogin: "Sistemaǵa kirisiw ushın",
  status: {
    PASSED_TEST: "Test tabıslı juwmaqlandi",
    FAILED_TEST: "Testten o'te almadı",
    TEST: "Test tapsırıw",
    MEETING: "Talapker menen ushırasıw",
    SEND_DOCUMENT: "Hújjetler jiberildi",
    SEEN: "Talapkerdiń hújjetleri kórip shıǵıldı ",
    REGISTERED: "Talapker dizimnen ótti",
    CONTRACT: "Shártnama",
    NOT_ACCEPTED: "Qabıl etilmedi",
    TEST_PROCESS: "Test baslandı",
    PASSED_MEETING: "Sáwbetten ótti",
    FAILED_MEETING: "Sáwbetten ótpedi",
    JOB_SUBMIT: "Jumısqa qabıl etilgen",
    DELETED: "Qaytarıp alınǵan",
  },
  warning: {
    enter: "Maǵlıwmatlardı tolıq kirgiziw kerek",
    noInformation: "Maǵlıwmat tabilmadı",
    noChoosen: "Fayl tańlanbaǵan",
    noInfo: "Eger sizde maǵlıwmat bolmasa",
    dataIncomplate: "Ótinish maǵlıwmatlardı tuwrı kiritiń",
    tokenExpired: "Token  múddeti tawsılǵan",
    sure: "Isenimińiz kámilma",
    finishTest: "Test waqtı tamamlandı",
    notSaved: "Ózgerisler saqlanbay qalmawı múmkin",
    successReg: "Dizimnen tabıslı óttińiz",
    warInfo: "Jeke kabinetingizdegi maǵlıwmatlardı toldırıń ",
    selectInfo: "Bul daǵazadaǵı bos jumıs ornına hújjet tapsırǵansız",
    loginInfo:
      "Hújjet jiberiwden aldın jeke kabinetińizge kirgen bolıwıńız kerek!",
  },
  percent: {
    title: "Procent",
    sign: "%",
  },
  allowance: {
    percent: "Procent %",
    department: "Bólim",
  },
  succes: {
    SEND_DOCUMENT: "Hújjetler jiberildi",
    saved: "Tabıslı saqlandi",
    createEmployee: "Xızmetker tabıslı jaratıldı!",
  },
  numberAnnounsment: "Daǵaza nomeri",
  orderNumber: "Tártip nomeri",
  transliteratsiya: "Transliteraciya",
  dashboard: "Menyu",
  total: "Ulıwma",
  empty: "Bos",
  other: "Basqalar",
  recentActivity: "Sońǵı háreketler",
  answerDoc: "Juwap xatı",
  login: {
    loginWithOneId: "One Id arqalı kiriw",
    videoInfo: "Tańlawǵa hújjetlerdi usınıw",
    videoLesson: "boyınsha video qollanba",
    email: "Elektron pochta mánzili",
    verify: "Tastıyıqlań",
    phone: "Telefon",
    byToken: "Gilt penen sistemaǵa kiriń",
    username: "Paydalanıwshı atı (Login)",
    password: "Parol",
    title: "Sistemaǵa kirisiw",
    account: "Esabınızǵa kiriń",
    come_out: "Kiriw",
    come_up: "Shıǵıw",
    update: "Gilt sózdi ózgertiw",
    userProfile: "Paydalanıwshınıń profili",
    currentPassword: "Házirgi gilt sózi",
    newPassword: "Jańa gilt sózi",
    confirmPassword: "Gilt sózdi tastıyıqlań",
    misMatch: "Parol tuwrı emes",
    inn: "STIN",
    fio: "Tolıq atı, familiyası",
    org: "Shólkem",
    srokLicence: "Sertifikattıń ámel qılıw múddeti",
    numberLicence: "Licenziya nomeri",

    enteredInfo: "Jeke maǵlıwmatlardı kirgiziw",
    ByregisteredInfo:
      "Dizimnen ótkenińizde paydalanǵan elektron pochta yamasa telefon nomerizdi kiritiń",
    forgetPasswordTitle:
      "Qawipsizlik sebepli, bul haqıyqattan da siz ekenligingizga isenim payda etiwimiz kerek. Dawam etiw ushın tómendegi jeke maǵlıwmatlarıńızdı qayta kiritiń.",
    forgetTitle: "Tómendegi jeke maǵlıwmatlarıńızdan birin kiritiń",
    byusername: "Paydalanıwshınıń atı",
    bypassport: "Pasport seriyasi hám nomeri",
    Byregistered:
      "Dizimnen ótkenińizde paydalanǵan elektron pochta yamasa telefon nomerdi saylań",
    sendConfirmCode: "Jiberilgen tastıyıqlaw kodı hám jańa paroldı kiritiń",
    confirmCode: "Tastıyıqlaw kodı",
    newPasswordEntered: "Jańa parol",
    forgetConfirm: "Tastıyıqlaw",

    forgetPassword: "Paroldı umıttıńız ba?",
    or: "Yamasa",
    account: "Akkount jaratasız ba?",
    registration: "Dizimnen ótiw",
    oferta: "Men ǵalabalıq usınıs shártlerin qabıl etemen",
    accountYes: "Akkountıńız barma?",
    verifiyCodeWhere: "Tastıyıqlaw kodın qay jerge jiberiw kerek?",
    enteredEmail: "Emaildi kiritiń",
    yourDid: "Siz bul zatlardı etdińiz!",
  },
  register: {
    text: {
      text1:
        "ÁDILLIK UYIMLARI HÁM SHÓLKEMLERINDE XIZMETKERLERDI JUMISQA QABILLAW TÁRTIBI",
      text2: "Ulıwma qaǵıydalar",
      text3:
        "Ádillik uyımları hám shólkemlerine jınsi, jası, ırqı, milleti, tili, social kelip shıǵıwı, múlkshilik jaǵdayı hám hámel poziciyasi, dinga bolǵan munasábeti, ıqtıqatı, jámiyetlik birlespelerine tiyisliliginen qaramastan, óziniń kásiplik, ıskerlik, jeke hám etikalıq pazıyletleri, maǵlıwmatı dárejesi hám sawlıgına kóre ádillik shólkemleri hám mákemelerine júkletilgen wazıypalardı orınlawǵa ılayıq bolǵan Ózbekstan Respublikası puqaraları yamasa Ózbekstan Respublikası Prezidentiniń ayrıqsha qararları menen ornatılǵan tártipte shet el mámleketlerdiń puqaraları hám puqaralıǵı bolmaǵan shaxslar qabıl etiledi.",
      text4:
        "Tómendegiler ádillik uyımları hám shólkemlerine jumısqa qabıl etiliwi múmkin emes:",
    },
    phone: "Telefon",
    getconfirmCode: "Jıberiw",
    title: "Dizimnen ótiw",
    firstName: "Atı",
    lastName: "Familiyası",
    username: "Paydalanıwshınıń atı (Login)",
    passport: "Pasport seriyası hám nomeri",
    password: "Parol",
    confirmPassword: "Paroldi tastıyıqlań",
    email: "E mail",
    confirmCode: "Tastıyıqlaw kodı",
    next: "Keyingi",
    info_1:
      "Dizimnen ótiwde yamasa paroldı qayta tiklewde mashqala júzege kelip",
    info_2: "telegram botga múrájat etiń",
  },
  actions: {
    usernameError: "Bos orın kirgiziw múmkin emes!",
    tests: "Testler dizimi",
    print: "Baspadan shıǵarıw",
    enteredEmail: "Elekton pochta adresińizdi kiritiń",
    enterPhone: "Telefon nomerińizdi kiritiń",
    changeInfo: "Maǵlıwmattı kirgiziw",
    selectKey: "Bul giltni saylań",
    read: "Oqıw",
    download: "Júklep alıw",
    uploadDiplom: "Diplomdı júklew",
    uploadObyektivka: "Obyektivkani júklew",
    select: "Tańlaw",
    selectVacancy: "Bos jumıs orınlarındı tańlaw",
    yes: "Awa",
    no: "Yaq",
    selectAnnoucement: "Daǵazanı tańlaw",
    back: "Arqaǵa",
    addQuestion: "Soraw jaratıw",
    uploadImage: "Súwret júklew",
    uploadCopy: "Pasport nusqasın júklew",
    sendDocument: "Hújjetlerdi jiberiw",
    send: "Jiberiw",
    clear: "Tazalaw",
    createEmployee: "Xızmetker jaratıw",
    sendForConfirmation: "Tastıyıqlaw ushın jiberiń",
    enterSomeThing: "Bir nárseni kiritiń..",
    title: "Háreketler",
    add: "Qosıw",
    save: "Saqlaw",
    cancel: "Bıykarlaw",
    next: "Keyingi",
    prev: "Aldınǵı",
    choose_file: "Fayldı saylań",
    filter: "Saralaw",
    delete: "Óshiriw",
    update: "Jańalaw",
    all: "Hámmesi",
    edit: "Redakciyalaw",
    editData: "Maǵlıwmatlardı redaktorlaw",
    displayAll: "Hámmesin kórsetiw",
    choosePhoto: "Súwretti saylań",
    selectAll: "Hámmesin saylań",
    createUser: "Paydalanıwshını jaratıń",
    finishTest: "Testti jumaqlaw ",
  },
  savol: {
    en: "Savol (lotin)",
    ru: "Вопрос(русский)",
    uz: "Савол(кирилл)",
    qr: "Soraw (latın)",
  },
  variant: {
    en: "Variant (lotin)",
    ru: "Вариант(русский)",
    uz: "Вариант(кирилл)",
    qr: "Variant (latın) ",
  },
  error: {
    passport_error:
      "Passport seriasini kirgiziw májburiy hám uzınlıǵı 2 bolıwı kerek",
    name_error: "Bul maydan bos bolıwı múmkin emes",
    netToken: "Sizde gilt joq",
    login_error: "Paydalanıwshı atı yamasa paroli qáte",
    already_success: "Siz dizimnen ótkensiz...",
    netAccess: "Ruxsat joq",
    title: "Qátelik! ",
  },
  staff: {
    totalStavka: "Ulıwma is tájiriybesi",
    stavka: "Stavka",
    salary: "Is haqı",
    arxiv: "Shtatlar kestesi arxivı",
    changeReason: "Shtatlar kestesiniń ózgeriwi sebebi",
    list: "Shtatlar kestesi",
    minSalary: "Eń kem is haqı",
    position: "Lawazım",
    typePosition: "Lawazım tu'ri",
    workWithDepartments: "Bólimler menen islew",
    workWithPosition: "Lawazımlar menen islew",
    staffCount: "Shtatlar sanı",
    status: "Status",
    vacancy: "Bos jumıs ornı",
    workLoadStaff: "Shtatlardıń is júklemeleri",
    refPosition: "Lawazımlar",
    allowances: "Jeńillikler",
    ranks: "Dáreje",
    tariff: "Anıqlama",
  },
  menu: "Menyu",
  employees: {
    pnfl: "FSHJIN kóriw",
    searchPnfl: "FSHJIN",
    dataPassport: "Pasport maǵlıwmatların alıw",
    addresss: "Mánzil",
    title: "Xızmetkerler",
    personalCard: "Jeke qaǵazı",
    birthDate: "Tuwılǵan sáne",
    appointmentsTransfers: "Tayınlanıw hám ótkeriw",
    rotation: "Xızmetkerlerdi rotaciya qılıw",
    dismissal: "Xızmetkerdi bosatıw",
    dismissedList: "Bosatılgan xızmetkerler dizimi",
    fullName: "FAÁ",
    language: "Til",
    language_status: "Til jaǵdayı",
    rectal: "Áskeriy ataq",
    holiday: "Bayramlar",
    profile: "Profil",
    profileBack: "Profilge qaytıw",
    ob: "Obyektivka",
    passport: "Pasport",
    endBeginPassport: "Pasporttıń tamamlanıw hám baslanıw sánesi",
    firstName: "Atı",
    lastName: "Familiyası",
    parentName: "Ákesiniń atı",
    email: "Elektron pochta mánzili",
    phone: "Telefon",
    mobilePhone: "Qosımsha telefon",
    address: "Jasaw mánzili",
    birthAddress: "Tuwılǵan jeri",
    birthRegion: "Tuwılǵan wálayatı",
    location: "Jasaw ornı",
    placeBirth: "Tuwılǵan jeri",
    passportId: "Pasport nomeri",
    passportGivenDate: "Pasport berilgen sáne",
    passportEndDate: "Passportning ámel qılıw múddeti",
    passportGivenWho: "Pasport kim tárepinen berilgen",
    inpc: "FSHJIN",
    photo: "Xızmetkerdiń fotosúwreti",
    copyPassport: "Pasport nusqası",
    manage: "Xızmetkerlerdi basqarıw",
    workingDetails: "Is detallari",
    seniority: "Is stajı",
    foreignLang: "Shet tiller",
    familyMembers: "Shańaraq aǵzaları",
    partyMembership: "Partiya aǵzalıǵı",
    academic_title: "Ilimiy ataq",
    academic_degree: "Ilimiy dárejesi",
    state_awards: "Mámleketlik sıylıqları",
    education: "Tálim",
    isHeDeputy: "Deputatlıǵı",
    phones: "Telefonlar",
    endDate: "Jumıstan bosatıw sánesi",
    beginDate: "Jumısqa jaylasıw sánesi",
    system: "Sistema",
    whereWorked: "Qay jerde hám kim bolıp islegen",
    givenYear: "Berilgen sáne",
    dead: "Qaytıs bolǵan",
    alive: "Tiri",
    reason: "Sebebi",
  },
  staffing: {
    title: "Shtatlar kestesi",
    totalVacancy: "Jámi bos jumıs orınları",
    totalStaff: "Ja'mi shtatlar sanı",
  },
  orders: {
    title: "Buyrıqlar",
    list: "Buyrıqlar dizimi",
    number: "Buyrıq nomeri",
    date: "Buyrıq sánesi",
    type: "Buyrıq túri",
    summary: "Juwmaq",
    contractNumber: "Miynet shártnaması nomeri",
    dateOfEmployment: "Jumısqa jaylasıw sánesi",
  },
  certification: {
    title: "Attestaciya",
  },
  vacation: {
    title: "Demalıs",
    send: "Demalısqa shıǵarıw",
    on: "Áyne waqıtta demalıstaǵı xızmetkerler",
    plan: "Demalıslar jobası",
    labor: "Jıllıq miynet demalısı",
    tempAllowance: "Miynetke uqıpsızlik beti",
    withoutPay: "Is haqı saqlanbaǵan halda beriletuǵın demalıs ",
    careChild: "Bala kútimi demalısı",
    nextlabor: "Náwbettegi miynet demalısına shıqqan xızmetkerler",
    withoutContent:
      "Is haqı saqlanbaǵan halda beriletuǵın demalısqa shıqqan xızmetkerler",
    sickWorkers: "Miynetke uqıpsızlıq sebepli demalısqa shıqqan xızmetkerler",
    maternity: "Bala kútimi demalısına shıqqan xızmetkerler",
  },
  monitoringEmployees: {
    title: "Xızmetkerlerdi monıtorıng qılıw",
  },
  businessTrips: {
    title: "Xızmet saparı",
    enterData: "Xızmet saparın belgilew",
    on: "Xızmet saparındaǵı xızmetkerler",
  },
  awardsAndBonus: {
    title: "Sıylıqlar hám imtiyazlar",
  },
  recruitment: {
    title: "Jumısqa qabıllaw",
    etap: "Basqısh",
    pasportData: "Pasport maǵlıwmatları",
    enterpasportData: "Kiritilgen pasport maǵlıwmatları",
    degreeEducation: "Ilimiy dárejesi",
    seniority: "Is tájiriybesi",
    familyMembers: "Shańaraq aǵzaları",
    additionalData: "Qosımsha maǵlıwmatlar",
  },
  departments: "Bólimler",
  references: {
    accept: "Qabıl etiw",
    title: "Málimleme",
    all: "Hámme málimlemeler",

    holiday: "Bayramlar",
    nationality: "Milleti",
    rectal: "Áskeriy ataǵı",
    spec_diplom: "Arnawlı diplom",
    news: " Jańalıqlar",
    country: "Mámleket",
    department_type: "Bo'lim túri",
    order_type: "Buyruq túri",
    work_mode: "Ish tartibi",
    department: "Bo'lim",
    holiday_type: "Bayram túrleri",
    gender: "Jınısı",
    marital_status: "Shańaraqqa tiyisli jaǵdayı",
    passport_seria: "Pasport seriyası",
    academic_degree: "Ilimiy dárejesi",
    academic_title: "Ilimiy ataq",
    award: "Sıylıq",
    exactAdress: "Waqtınsha turar orını",
    education: "Maǵlıwmatı",
    propis: "Turaqlı jasaw orını",
    region: "Jasaw aymaǵı",
    regions: "Tuwılǵan aymaǵı",
    language: "Til",
    passportTYpe: "Pasport túri",
    language_status: "Til jaǵdayı",
    military_rank: "Áskeriy ataq",
    party_membership: "Partiyaǵa aǵzalıq",
    reason_for_dismissal: "Jumıstan bosatıw sebebi",
    educational_institution: "Bilimlendiriw shólkemi",
    education_type: "Maǵlıwmatı boyınsha qánigeligi",
    family_member: "Shańaraq aǵzaları",
    directory_phone_type: "Telefon túri",
    vatInfo: "QQS (%)",
    bankRequesit: "Bank rekvizitları",
    bank: "Bank",
    bankAccountType: "Esap túri",
    accountNumber: "Bank esap beti",
    depManagement: "Bólimlerdi basqarıw",
    endDate: "Pitkeriw jılı",
  },
  name: {
    en: "Nomi(lotin)",
    ru: "Nomi(rus)",
    uz: "Nomi(kirill)",
    qr: "Atı(latın)",
  },
  address: {
    title: "Mánzil",
    lt: "Manzil(lotin)",
    ru: "Адрес(русский)",
    uz: "Manzil(кирилл)",
    qr: "Mánzil (latın)",
    physical: "Fizikalıq jaylasıwı",
    legal: "Yuridikalıq mánzili",
    phone: "Telefon",
    email: "Elektron pochta mánzili",
  },
  userManagement: {
    title: "Paydalanıwshılardı basqarıw",
    roles: "Roller",
    permissions: "Ruxsatlar",
    users: "Paydalanıwshılar",
  },
  roles: {
    name: "Ataması",
    code: "Kodı",
    permissions: "Ruxsatlar",
  },
  permissions: {
    title: "Ruxsatlar",
    name: "Atı",
    type: "Túri",
    code: "Kodı",
    sort: "Saralaw",
  },
  date: "Sáne",
  createdDate: "Jaratılǵan sáne",
  confirm_delete: "Haqıyqattan da óshirmekshisiz ba",

  permessionMangement: {
    References: "Málimleme",
    Department: "Bólim",
    DirectoryOrder: "Buyrıqlar dizimi",
    EmployeeAllowance: "Imtiyazlar",
    EmployeeAcademicTitle: "Ilimiy ataq",
    EmployeeLanguage: "Til",
    EmployeeAward: "Sıylıq",
    EmployeeRectal: "Áskeriy ataǵı",
    EmployeeWork: "Xızmetkerlerdiń jumısı",
    Employee: "Xızmetkerler",
    EmployeeFamilyMember: "Shańaraq aǵzaları",
    EmployeeMemberOfDeputy: "Deputatlıǵı",
    EmployeeAcademicDegree: "Ilimiy dárejesi",
    EmployeeEducation: "Bilimlendiriw",
    EmployeeHoliday: "Bayramlar",
    MemberOfDeputy: "Partiya aǵzalıǵı",
    EmployeePhoto: "Xızmetkerlerdiń fotosureti",
    EmployeePhoneNumber: "Telefon",
    EmployeeExperience: "Is tájiriybesi",
    EmployeePartial: "Bólegi",
    EmployeeWageHistory: "Is haqı tariyxı ",
    EmployeePassportScan: "Pasport nusqası",

    //STAFF
    StaffListCheckAllowance: "Jeńilliklerdi tekseriń",
    StaffList: "Xızmetkerler kestesi",
    StaffPosition: "Lawazım",
    StaffListChangeReason: "Kadrlar kestesindegi ózgerislerdiń sebebi",
    StaffListArchive: "Kadrlar arxivı",
    StaffMinSalary: "Minimal is haqı",
    StaffListAllowance: "Imtiyazlar",
    DepartmentAddress: "Bólim mánzili",
    TimeSheetControl: "Waqıt beti",
    BankRequisite: "Bank detalları",
    News: "Jańalıqlar",
    Role: "Roller",
    VATInfo: "QQS (%)",
    User: "Paydalanıwshılar",
  },
  forgetPasswordText:
    "Dizimnen ótken tel nomerińizge kodtı jiberiwimiz ushın passport maǵlıwmatıńızdı kiritiń:",
  required_error: "Barlıq kerekli maydanlardı toldırıń",
  send_code: "Telefon nomerińizge kod jiberildi!",
  success: "Tabıslı saqlandi !",
  password_error: "Parol 8 xanadan kem bolıwı kerek emes!",
  resultFound: "__ daǵaza tabıldı",
  returnDocument: "Hújjetti qaytarıp alıw",
  returned: "Hújjet qaytarıp alındı",
  statusAriza: "ARZANIŃ ÁMELDEGI JAǴDAYI",
  archiveInfo: "Ózgerisler tariyxı",
  updatedDate: "Ózgertirilgen sáne",
  archive: "arxiv",
  returnDoc:
    "Eslatma: Hújjet qaytarıp alınǵannan keyin, bul daǵaza sheńberinde hújjetler jáne qayta jiberilmeydi",
  onlyLotin: "Kirill álipbesi háriplerin isletiw múmkin emes",
  agreeTest: "Tartib bilan tanishib chiqdim, testlarni yechishga tayyorman",
  alertText: `Adliya vazirligining axborot resurslari uchun internet tarmog‘iga ulanish xizmatlarini ko‘rsatuvchi “ONE-NET” operatori tomonidan 2023 yilning <b> 9-10-11 iyun  kunlari soat 00-00 dan 06-00 ga qadar</b> texnik ishlari olib borilishi munosabati bilan Adliya vazirligi axborot tizimlari ishida qisqa muddatli uzilishlar kuzatilishi mumkin.
  <br/> <strong> Shu sababli nomzodlarga ushbu vaqt oralig‘ida bo‘sh ish o‘rinlari bo‘yicha tanlovlarning  test sinovini topshirish tavsiya qilinmaydi.</strong>`,
  notice: "Eslatma",
  IAgree  : "Tanishdim"

};
